// @ts-nocheck
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function EmergencyStopButton() {
  const [isStopping, setIsStopping] = useState(false);

  const handleEmergencyStop = async () => {
    const confirmed = window.confirm(
      '⚠️ EMERGENCY STOP\n\n' +
      'This will CANCEL all pending newsletter emails.\n\n' +
      'Emails that have already been sent cannot be recalled.\n\n' +
      'Continue?'
    );

    if (!confirmed) return;

    const doubleConfirm = window.prompt(
      'Type STOP in all caps to confirm emergency cancellation:'
    );

    if (doubleConfirm !== 'STOP') {
      toast.error('Emergency stop cancelled');
      return;
    }

    setIsStopping(true);
    try {
      // Cancel all pending newsletter emails
      const { error } = await supabase
        .from('communication_logs')
        .update({ status: 'cancelled' })
        .eq('status', 'pending')
        .eq('type', 'email');

      if (error) throw error;

      toast.success('All pending emails have been cancelled');
    } catch (error: any) {
      console.error('Error stopping emails:', error);
      toast.error(error.message || 'Failed to stop emails');
    } finally {
      setIsStopping(false);
    }
  };

  return (
    <Button
      onClick={handleEmergencyStop}
      disabled={isStopping}
      variant="destructive"
      size="sm"
      className="gap-2"
    >
      <AlertCircle className="h-4 w-4" />
      {isStopping ? 'Stopping...' : 'Emergency Stop All Emails'}
    </Button>
  );
}